<template>
  <section class="w-calendar-screen" aria-label="Календарь приёма">
    <CalendarToolbar />
    <ScheduleBuilder v-if="store.builderOpen" />
    <div class="w-patient-context">{{ patientText }}</div>
    <SlotSelection />
    <div class="w-branch-calendar-note">{{ branchNote }}</div>
    <WeekGrid />
    <div class="w-legend" aria-label="Занятость кабинета">
      <span v-for="item in LEGEND" :key="item.color" class="w-legend-item">
        <span class="w-swatch" :class="item.color" />
        {{ item.text }}
      </span>
    </div>
    <div class="w-directory">
      <span class="w-directory-label">Кабинеты</span>
      <span v-for="room in store.allowedRooms" :key="room.id">
        <strong>{{ room.number ?? room.id }}</strong>{{ room.purpose || room.name }}
      </span>
      <span>{{ store.currentBranch?.name }}</span>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { formatDate, hoursText } from '~utils/calendarModel';
import CalendarToolbar from './CalendarToolbar.vue';
import ScheduleBuilder from './ScheduleBuilder.vue';
import SlotSelection from './SlotSelection.vue';
import WeekGrid from './WeekGrid.vue';

const LEGEND = [
  { color: 'green', text: 'Свободен для вас' },
  { color: 'yellow', text: 'Запланирован коллегами' },
  { color: 'red', text: 'Есть пациент' },
  { color: 'gray', text: 'Перерыв или приём закрыт' },
];

const store = useScheduleStore();

const patientText = computed(() => (
  store.patientId
    ? `Для записи выбран пациент №${store.patientId}`
    : 'Пациент не выбран. Выберите пациента на основной странице.'
));

const branchNote = computed(() => {
  const branch = store.currentBranch;
  const day = store.branchDay(store.date);
  const hours = day.open.length
    ? `работа ${hoursText(day.open)} · приём ${hoursText(day.intake)}`
    : 'филиал закрыт';
  return [
    branch?.name,
    formatDate(store.date, { day: 'numeric', month: 'long' }),
    hours,
    day.isException && day.label,
    branch?.timeZone || 'время филиала',
  ].filter(Boolean).join(' · ');
});
</script>
